"use client"
import classNames from "classnames";
import LoadingIndicator from "src/components/loadingindicator/LoadingIndicator";
import useIsConsentReady from "src/lib/client/useIsConsentReady";
import styles from "./EmbedConsentPlaceholder.module.css";

//#region [Props]
type EmbedConsentPlaceholderProps = {
    consentNeeded?: "preferences" | "statistics" | "marketing";
    className?: string;
};
//#endregion

//#region [Component]
export default function EmbedConsentPlaceholder({ consentNeeded = "marketing", className }: EmbedConsentPlaceholderProps) {
    const {isConsentReady, resetConsentStatus} = useIsConsentReady(consentNeeded);

    let _cookiesNeeded = "markedsførings";
    switch (consentNeeded) {
        case "preferences":
            _cookiesNeeded = "preferanse";
            break;
        case "statistics":
            _cookiesNeeded = "statistikk";
            break;
    }

    return <div onClick={resetConsentStatus} className={classNames(styles.SEmbedConsentPlaceholder, className)}>
        <div className={styles.SConsentNeededTrigger} >
            For å se dette innholdet må {_cookiesNeeded}-cookies være slått på. Klikk her for å endre dine innstillinger.
            { typeof isConsentReady === "undefined" && <LoadingIndicator size="large" position="AbsoluteCenter" label="Venter på cookies"/>}
        </div>
    </div>;
}
//#endregion